import React, { useCallback, useState } from "react";
// import "@shopify/polaris/build/esm/styles.css";
import {
  BrowserRouter,
  useRoutes, // instead of "Switch"
} from "react-router-dom";
import "./Assets/Styles/globals.css";
import "./Assets/Styles/react-tagsinput.css";
import Login from "./Pages/Authentication/Login";
import NavigationLayout from "./Components/NavigationLayout";
import UsersAndPermissions from "./Pages/Settings/UsersAndPermissions";
import IntroScreens from "./Pages/IntroScreens/List";
import AddEditItem from "./Pages/IntroScreens/AddEdit";
import AddEditUser from "./Pages/Settings/AddEditUser";
import Elements from "./Pages/Elements/List";
import AddEditElement from "./Pages/Elements/AddEdit";
import Instructors from "./Pages/Instructors/List";
import AddEditInstructor from "./Pages/Instructors/AddEdit";
import Studios from "./Pages/Studios/List";
import AddEditStudio from "./Pages/Studios/AddEdit";
import Currency from "./Pages/Settings/Currency";
import TermsAndConditions from "./Pages/TermsAndConditions";
import InstructorGallery from "./Pages/Instructors/Gallery/List";
import AddEditGalleryInstructor from "./Pages/Instructors/Gallery/AddEdit";
import Users from "./Pages/Users/List";
import UserDetails from "./Pages/Users/UserDetails";
import Reviews from "./Pages/Reviews/Reviews";
import ReviewDetails from "./Pages/Reviews/ReviewDetails";
import InstructorReviews from "./Pages/Instructors/Reviews/Reviews";
import InstructorReviewDetails from "./Pages/Instructors/Reviews/ReviewDetails";
import Classes from "./Pages/Classes/List";
import AddEditClass from "./Pages/Classes/AddEdit";
import Sessions from "./Pages/Classes/Sessions/List";
import AddEditSession from "./Pages/Classes/Sessions/AddEdit";
import SessionGallery from "./Pages/Classes/Gallery/List";
import AddEditGallerySession from "./Pages/Classes/Gallery/AddEdit";
import ClassReviewDetails from "./Pages/Classes/Reviews/ReviewDetails";
import ClassReviews from "./Pages/Classes/Reviews/Reviews";
import Substudios from "./Pages/Substudios/List";
import AddEditSubstudio from "./Pages/Substudios/AddEdit";
import RecentSessions from "./Pages/RecentSessions/List";
import RecentSessionDetails from "./Pages/RecentSessions/SessionsDetails";
import News from "./Pages/News/List";
import AddEditNews from "./Pages/News/AddEdit";
import Packages from "./Pages/Packages/List";
import AddEditPackage from "./Pages/Packages/AddEdit";
import Subpackages from "./Pages/Packages/Subpackages/List";
import AddEditSubpackage from "./Pages/Packages/Subpackages/AddEdit";
import Memberships from "./Pages/Memberships/List";
import AddEditMembership from "./Pages/Memberships/AddEdit";
import Submemberships from "./Pages/Memberships/Submemberships/List";
import AddEditSubmembership from "./Pages/Memberships/Submemberships/AddEdit";
import PackageSubscribers from "./Pages/Packages/Subscribers/List";
import PackageSubscriberDetails from "./Pages/Packages/Subscribers/SubscriberDetails";
import Bookings from "./Pages/Classes/Bookings/List";
import BulkSessions from "./Pages/BulkSessions/BulkSessions";
import MembershipSubscriberDetails from "./Pages/Memberships/Subscribers/SubscriberDetails";
import MembershipSubscribers from "./Pages/Memberships/Subscribers/List";
import Reports from "./Pages/Reports/List";
import ReportDetails from "./Pages/Reports/ReportDetails";
import Book from "./Pages/Classes/Bookings/Book";
import ReportsBookings from "./Pages/ReportsBookings/List";
import ReportBookingDetails from "./Pages/ReportsBookings/ReportDetails";
import BookSubpackage from "./Pages/Packages/Subscribers/Book";
import BookSubmembership from "./Pages/Memberships/Subscribers/Book";
import WaitingList from "./Pages/Classes/WaitingList/List";
import WaitingListDetails from "./Pages/Classes/WaitingList/Details";
import EditUser from "./Pages/Users/Edit";
import Payments from "./Pages/Users/Payments";
import ContactUs from "./Pages/Settings/ContactUs";
import PastAndUpcomingSessions from "./Pages/PastAndUpcomingSessions/List";
import SessionDetails from "./Pages/PastAndUpcomingSessions/Details";
import AddEditEvent from "./Pages/Classes/AddEditEvent";
import PricingOptions from "./Pages/Classes/PricingOptions/List";
import AddEditPricingOption from "./Pages/Classes/PricingOptions/AddEdit";
import AddEditEventSession from "./Pages/Classes/Sessions/AddEditEventSession";
import Rooms from "./Pages/Rooms/List";
import AddEditRoom from "./Pages/Rooms/AddEdit";
import EditSubpackageSubsriber from "./Pages/Packages/Subscribers/Edit";
import EditSubmembershipSubsriber from "./Pages/Memberships/Subscribers/Edit";
import EditBooking from "./Pages/Classes/Bookings/Edit";
import Subscribers from "./Pages/Subscribers/List";
import SubscriptionDetails from "./Pages/Subscribers/Details";
import EditTransaction from "./Pages/ReportsBookings/EditTransaction";
import WaitinListPastUpcoming from "./Pages/PastAndUpcomingSessions/WaitinListPastUpcoming";
import BookPastUpcoming from "./Pages/PastAndUpcomingSessions/BookPastUpcoming";
import Orders from "./Pages/Orders/List";
import OrdersByDay from "./Pages/Orders/OrdersByDay";
import OrdersDetails from "./Pages/Orders/OrdersDetails";
import AddEditEventSessionExisting from "./Pages/Classes/Sessions/AddEditEventSessionExisting";
import AddEditCourse from "./Pages/Courses/AddEdit";
import Courses from "./Pages/Courses/List";
import CourseSubscribers from "./Pages/Courses/Subscribers/List";
import BookCourseSubscriber from "./Pages/Courses/Subscribers/Book";
import EditCourseSubsriber from "./Pages/Courses/Subscribers/Edit";
import CourseSubscriberDetails from "./Pages/Courses/Subscribers/SubscriberDetails";
import BookingsCourse from "./Pages/Courses/Bookings/List";
import EditBookingCourse from "./Pages/Courses/Bookings/Edit";
import WalletReports from "./Pages/WalletReports/List";
import WalletPayments from "./Pages/WalletPayments/List";
import WalletTopupReports from "./Pages/WalletTopupReports/List";
import OnDemandVideos from "./Pages/OnDemandVideos/List";
import AddEditOnDemandVideo from "./Pages/OnDemandVideos/AddEdit";
import OnDemandVideoSubscribers from "./Pages/OnDemandVideos/Subscribers/List";
import EditOnDemandSubscriber from "./Pages/OnDemandVideos/Subscribers/Edit";
import PurchaseOnDemandVideo from "./Pages/OnDemandVideos/Subscribers/Purchase";
import BirthdayPackages from "./Pages/BirthdayPackages/List";
import AddEditBirthdayPackage from "./Pages/BirthdayPackages/AddEdit";

function App() {
  if (process.env.NODE_ENV === "production") {
    console.log = function () {};
  }

  return useRoutes([
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "/admin/settings/currency",
      element: (
        <NavigationLayout>
          <Currency />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/terms-and-conditions",
      element: (
        <NavigationLayout>
          <TermsAndConditions />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/settings/users-and-permissions",
      element: (
        <NavigationLayout>
          <UsersAndPermissions />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/settings/users-and-permissions/new",
      element: (
        <NavigationLayout>
          <AddEditUser type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/settings/users-and-permissions/:id",
      element: (
        <NavigationLayout>
          <AddEditUser type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/intro-screens",
      element: (
        <NavigationLayout>
          <IntroScreens />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/intro-screens/new",
      element: (
        <NavigationLayout>
          <AddEditItem type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/intro-screens/:id",
      element: (
        <NavigationLayout>
          <AddEditItem type="edit" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/elements",
      element: (
        <NavigationLayout>
          <Elements />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/elements/new",
      element: (
        <NavigationLayout>
          <AddEditElement type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/elements/:id",
      element: (
        <NavigationLayout>
          <AddEditElement type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/elements/:id/categories",
      element: (
        <NavigationLayout>
          <Studios />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/elements/:id/categories/new",
      element: (
        <NavigationLayout>
          <AddEditStudio type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/elements/:id/categories/:studioId",
      element: (
        <NavigationLayout>
          <AddEditStudio type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/elements/:id/categories/:studioId/studios",
      element: (
        <NavigationLayout>
          <Substudios />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/elements/:id/categories/:studioId/studios/new",
      element: (
        <NavigationLayout>
          <AddEditSubstudio type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/elements/:id/categories/:studioId/studios/:substudioId",
      element: (
        <NavigationLayout>
          <AddEditSubstudio type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/instructors",
      element: (
        <NavigationLayout>
          <Instructors />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/instructors/new",
      element: (
        <NavigationLayout>
          <AddEditInstructor type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/instructors/:id",
      element: (
        <NavigationLayout>
          <AddEditInstructor type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/instructors/:id/gallery",
      element: (
        <NavigationLayout>
          <InstructorGallery />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/instructors/:id/gallery/new",
      element: (
        <NavigationLayout>
          <AddEditGalleryInstructor type="add" />
        </NavigationLayout>
      ),
    },
    // {
    //   path: "/admin/instructors/:id/gallery/:galleryId",
    //   element: (
    //     <NavigationLayout>
    //       <AddEditImage type="edit" />
    //     </NavigationLayout>
    //   ),
    // },
    {
      path: "/admin/classes",
      element: (
        <NavigationLayout>
          <Classes title="Classes" path="classes" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/classes/new",
      element: (
        <NavigationLayout>
          <AddEditClass type="add" path="classes" title="Add Class" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/classes/:id",
      element: (
        <NavigationLayout>
          <AddEditClass type="edit" path="classes" title="Edit Class" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/courses",
      element: (
        <NavigationLayout>
          <Courses />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/new",
      element: (
        <NavigationLayout>
          <AddEditCourse type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id",
      element: (
        <NavigationLayout>
          <AddEditCourse type="edit" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/courses/:id/sessions",
      element: (
        <NavigationLayout>
          <Sessions path="courses" is_course="yes" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/sessions/new",
      element: (
        <NavigationLayout>
          <AddEditSession type="add" path="courses" is_course="yes" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/sessions/:sessionId",
      element: (
        <NavigationLayout>
          <AddEditSession type="edit" path="courses" is_course="yes" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/sessions/:sessionId/bookings",
      element: (
        <NavigationLayout>
          <BookingsCourse type="sessions" path="courses" is_course="yes" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/courses/:id/subscribers/book",
      element: (
        <NavigationLayout>
          <BookCourseSubscriber />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/subscribers/:subscriberId/edit/:pivot",
      element: (
        <NavigationLayout>
          <EditCourseSubsriber />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/subscribers",
      element: (
        <NavigationLayout>
          <CourseSubscribers />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/subscribers/:subscriberId",
      element: (
        <NavigationLayout>
          <CourseSubscriberDetails />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/sessions/:sessionId/bookings/edit/:bookingId",
      element: (
        <NavigationLayout>
          <EditBookingCourse />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/events",
      element: (
        <NavigationLayout>
          <Classes title="Events" path="events" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/events/new",
      element: (
        <NavigationLayout>
          <AddEditEvent type="add" path="events" title="Add Event" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/events/:id",
      element: (
        <NavigationLayout>
          <AddEditEvent type="edit" path="events" title="Edit Event" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/events/:id/pricing-options",
      element: (
        <NavigationLayout>
          <PricingOptions />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/events/:id/pricing-options/new",
      element: (
        <NavigationLayout>
          <AddEditPricingOption type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/events/:id/pricing-options/:optionId",
      element: (
        <NavigationLayout>
          <AddEditPricingOption type="edit" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/events/:id/gallery",
      element: (
        <NavigationLayout>
          <SessionGallery path="events" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/events/:id/gallery/new",
      element: (
        <NavigationLayout>
          <AddEditGallerySession type="add" path="events" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/events/:id/gallery/:galleryId",
      element: (
        <NavigationLayout>
          <AddEditGallerySession type="edit" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/classes/:id/gallery",
      element: (
        <NavigationLayout>
          <SessionGallery path="classes" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/classes/:id/gallery/new",
      element: (
        <NavigationLayout>
          <AddEditGallerySession type="add" path="classes" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/classes/:id/gallery/:galleryId",
      element: (
        <NavigationLayout>
          <AddEditGallerySession type="edit" path="classes" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/classes/:id/sessions",
      element: (
        <NavigationLayout>
          <Sessions path="classes" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/classes/:id/sessions/new",
      element: (
        <NavigationLayout>
          <AddEditSession type="add" path="classes" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/classes/:id/sessions/:sessionId",
      element: (
        <NavigationLayout>
          <AddEditSession type="edit" path="classes" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/classes/:id/sessions/:sessionId/bookings",
      element: (
        <NavigationLayout>
          <Bookings type="sessions" path="classes" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/classes/:id/sessions/:sessionId/bookings/book",
      element: (
        <NavigationLayout>
          <Book path="classes" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/classes/:id/sessions/:sessionId/bookings/edit/:bookingId",
      element: (
        <NavigationLayout>
          <EditBooking path="classes" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/events/:id/sessions/:sessionId/bookings/edit/:bookingId",
      element: (
        <NavigationLayout>
          <EditBooking path="events" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/events/:id/sessions/:sessionId/bookings/book",
      element: (
        <NavigationLayout>
          <Book path="events" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/classes/:id/sessions/:sessionId/waiting-list",
      element: (
        <NavigationLayout>
          <WaitingList path="classes" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/events/:id/sessions/:sessionId/waiting-list",
      element: (
        <NavigationLayout>
          <WaitingList path="events" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/events/:id/sessions",
      element: (
        <NavigationLayout>
          <Sessions path="events" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/events/:id/sessions/new",
      element: (
        <NavigationLayout>
          <AddEditEventSession type="add" path="events" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/events/:id/sessions/new-existing",
      element: (
        <NavigationLayout>
          <AddEditEventSessionExisting type="add" path="events" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/events/:id/sessions/existing/:sessionId",
      element: (
        <NavigationLayout>
          <AddEditEventSessionExisting type="edit" path="events" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/events/:id/sessions/:sessionId",
      element: (
        <NavigationLayout>
          <AddEditEventSession type="edit" path="events" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/events/:id/sessions/:sessionId/bookings",
      element: (
        <NavigationLayout>
          <Bookings type="sessions" path="events" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/users",
      element: (
        <NavigationLayout>
          <Users />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/users/:id",
      element: (
        <NavigationLayout>
          <UserDetails />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/users/:id/edit",
      element: (
        <NavigationLayout>
          <EditUser />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/users/:id/payments",
      element: (
        <NavigationLayout>
          <Payments />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/orders",
      element: (
        <NavigationLayout>
          <Orders />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/orders/:id",
      element: (
        <NavigationLayout>
          <OrdersByDay />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/orders/:id/details/:orderId",
      element: (
        <NavigationLayout>
          <OrdersDetails />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/reviews",
      element: (
        <NavigationLayout>
          <Reviews />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/reviews/:id",
      element: (
        <NavigationLayout>
          <Reviews />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/reviews/sessions/:id",
      element: (
        <NavigationLayout>
          <ReviewDetails api="class-reviews" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/reviews/instructors/:id",
      element: (
        <NavigationLayout>
          <ReviewDetails api="instructor-reviews" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/instructors/:instructorId/reviews",
      element: (
        <NavigationLayout>
          <InstructorReviews />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/instructors/:instructorId/reviews/:id",
      element: (
        <NavigationLayout>
          <InstructorReviewDetails />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/classes/:classId/reviews",
      element: (
        <NavigationLayout>
          <ClassReviews path="classes" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/classes/:classId/reviews/:id",
      element: (
        <NavigationLayout>
          <ClassReviewDetails path="classes" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/events/:classId/reviews",
      element: (
        <NavigationLayout>
          <ClassReviews path="events" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/events/:classId/reviews/:id",
      element: (
        <NavigationLayout>
          <ClassReviewDetails path="events" />
        </NavigationLayout>
      ),
    },
    // {
    //   path: "/admin/recent-sessions",
    //   element: (
    //     <NavigationLayout>
    //       <RecentSessions />
    //     </NavigationLayout>
    //   ),
    // },
    // {
    //   path: "/admin/recent-sessions/:id",
    //   element: (
    //     <NavigationLayout>
    //       <RecentSessionDetails />
    //     </NavigationLayout>
    //   ),
    // },
    // {
    //   path: "/admin/recent-sessions/:id/bookings",
    //   element: (
    //     <NavigationLayout>
    //       <Bookings type="recent-sessions" />
    //     </NavigationLayout>
    //   ),
    // },
    {
      path: "/admin/news",
      element: (
        <NavigationLayout>
          <News />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/news/new",
      element: (
        <NavigationLayout>
          <AddEditNews type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/news/:id",
      element: (
        <NavigationLayout>
          <AddEditNews type="edit" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/packages",
      element: (
        <NavigationLayout>
          <Packages />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/packages/new",
      element: (
        <NavigationLayout>
          <AddEditPackage type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/packages/:id",
      element: (
        <NavigationLayout>
          <AddEditPackage type="edit" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/packages/:id/subpackages",
      element: (
        <NavigationLayout>
          <Subpackages />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/packages/:id/subpackages/new",
      element: (
        <NavigationLayout>
          <AddEditSubpackage type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/packages/:id/subpackages/:subpackageId",
      element: (
        <NavigationLayout>
          <AddEditSubpackage type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/packages/:id/subpackages/:subpackageId/subscribers",
      element: (
        <NavigationLayout>
          <PackageSubscribers />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/packages/:id/subpackages/:subpackageId/subscribers/:subscriberId/details/:pivot",
      element: (
        <NavigationLayout>
          <PackageSubscriberDetails />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/packages/:id/subpackages/:subpackageId/subscribers/:subscriberId/edit/:pivot",
      element: (
        <NavigationLayout>
          <EditSubpackageSubsriber />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/packages/:id/subpackages/:subpackageId/subscribers/book",
      element: (
        <NavigationLayout>
          <BookSubpackage />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/memberships/:id/submemberships/:submembershipId/subscribers/book",
      element: (
        <NavigationLayout>
          <BookSubmembership />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/memberships/:id/submemberships/:submembershipId/subscribers",
      element: (
        <NavigationLayout>
          <MembershipSubscribers />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/memberships/:id/submemberships/:submembershipId/subscribers/:subscriberId/details/:pivot",
      element: (
        <NavigationLayout>
          <MembershipSubscriberDetails />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/memberships/:id/submemberships/:submembershipId/subscribers/:subscriberId/edit/:pivot",
      element: (
        <NavigationLayout>
          <EditSubmembershipSubsriber />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/memberships",
      element: (
        <NavigationLayout>
          <Memberships />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/memberships/new",
      element: (
        <NavigationLayout>
          <AddEditMembership type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/memberships/:id",
      element: (
        <NavigationLayout>
          <AddEditMembership type="edit" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/memberships/:id/submemberships",
      element: (
        <NavigationLayout>
          <Submemberships />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/memberships/:id/submemberships/new",
      element: (
        <NavigationLayout>
          <AddEditSubmembership type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/memberships/:id/submemberships/:submembershipId",
      element: (
        <NavigationLayout>
          <AddEditSubmembership type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/classes/bulk-sessions",
      element: (
        <NavigationLayout>
          <BulkSessions />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/logs",
      element: (
        <NavigationLayout>
          <Reports />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/wallet-reports",
      element: (
        <NavigationLayout>
          <WalletReports />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/wallet-topup-reports",
      element: (
        <NavigationLayout>
          <WalletTopupReports />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/logs/:id",
      element: (
        <NavigationLayout>
          <ReportDetails />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/bookings",
      element: (
        <NavigationLayout>
          <ReportsBookings />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/bookings/:id",
      element: (
        <NavigationLayout>
          <ReportBookingDetails />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/bookings/edit/:id",
      element: (
        <NavigationLayout>
          <EditTransaction />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/settings/contact-us",
      element: (
        <NavigationLayout>
          <ContactUs />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/sessions",
      element: (
        <NavigationLayout>
          <PastAndUpcomingSessions />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/sessions/:id",
      element: (
        <NavigationLayout>
          <SessionDetails />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/sessions/:id/classes/:classId/bookings",
      element: (
        <NavigationLayout>
          <Bookings type="recent-sessions" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/sessions/:sessionId/classes/:classId/bookings/book",
      element: (
        <NavigationLayout>
          <BookPastUpcoming />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/sessions/:sessionId/classes/:classId/bookings/waiting-list",
      element: (
        <NavigationLayout>
          <WaitinListPastUpcoming />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/sessions/:id/bookings/classes/:classId/book",
      element: (
        <NavigationLayout>
          <BookPastUpcoming />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/sessions/:id/classes/:classId/bookings/edit/:bookingId",
      element: (
        <NavigationLayout>
          <EditBooking path="sessions" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/rooms",
      element: (
        <NavigationLayout>
          <Rooms />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/rooms/new",
      element: (
        <NavigationLayout>
          <AddEditRoom type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/rooms/:id",
      element: (
        <NavigationLayout>
          <AddEditRoom type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/subscriptions",
      element: (
        <NavigationLayout>
          <Subscribers />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/subscriptions/:id",
      element: (
        <NavigationLayout>
          <SubscriptionDetails />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/wallet-payments",
      element: (
        <NavigationLayout>
          <WalletPayments />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/on-demand-videos",
      element: (
        <NavigationLayout>
          <OnDemandVideos />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/on-demand-videos/new",
      element: (
        <NavigationLayout>
          <AddEditOnDemandVideo type="new" title="Add On Demand Video" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/on-demand-videos/:id/subscribers/:subscriberId/edit/:bookingId",
      element: (
        <NavigationLayout>
          <EditOnDemandSubscriber />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/on-demand-videos/:id/subscribers/purchase",
      element: (
        <NavigationLayout>
          <PurchaseOnDemandVideo />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/on-demand-videos/:id/subscribers",
      element: (
        <NavigationLayout>
          <OnDemandVideoSubscribers />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/on-demand-videos/:id",
      element: (
        <NavigationLayout>
          <AddEditOnDemandVideo type="edit" title="Edit On Demand Video" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/birthday-packages",
      element: (
        <NavigationLayout>
          <BirthdayPackages />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/birthday-packages/new",
      element: (
        <NavigationLayout>
          <AddEditBirthdayPackage type="add" title="Add Birthday Package" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/birthday-packages/:id",
      element: (
        <NavigationLayout>
          <AddEditBirthdayPackage type="edit" title="Edit Birthday Package" />
        </NavigationLayout>
      ),
    },
  ]);
}
export default App;
